import { Box } from '@mui/material';
import React from 'react'
import { FaWhatsapp } from "react-icons/fa";
import { RiTelegram2Line } from "react-icons/ri";

function HelpPage() {
  return (
    <Box className="help-container" style={{ padding: '20px', maxWidth: '800px', margin: '0' }}>
    
      <p style={{ marginTop: '20px', fontSize: '16px' }}>
        Если вам требуется помощь и возникли вопросы, пишите:
      </p>
      <ul style={{ marginTop: '10px', listStyleType: 'none', padding: 0 }}>
        <li style={{ marginBottom: '10px' }}>
          <a 
            href="https://wa.me/79882602218" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              textDecoration: 'none', 
              color: '#25D366', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            <FaWhatsapp style={{ fontSize: '20px' }} /> +7988-260-22-18
          </a>
        </li>
        <li>
          <a 
            href="https://t.me/reldo_crm" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              textDecoration: 'none', 
              color: '#0088cc', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            <RiTelegram2Line style={{ fontSize: '20px' }} /> @reldo_crm
          </a>
        </li>
        <p className='mt-8'>Также подписывайтесь на наш канал в Telegram, где мы будем делиться новостями и обновлениями</p>
        <li>
        <a 
            href="https://t.me/reldo_news" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              textDecoration: 'none', 
              color: '#0088cc', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}  
          >
            <RiTelegram2Line style={{ fontSize: '20px' }} /> @reldo_news
          </a>
        </li>
      </ul>
    </Box>
  )
}

export default HelpPage